<template>  
  <fieldset class="input input--checkbox-group" :class="inputClass" :group="group">
    <legend v-if="label">{{ label }}</legend>
    <label v-for="option in options">{{ option.label }}
      <input :id="option.value" :value="option.value" type="checkbox" v-model="selected" :disabled="option.disabled" :name="group" @change.prevent="onChange"/><span class="checkbox-toggle">
        <icon class="checkbox-checkmark" name="checkmark_small" size="10px"></icon></span>
    </label>
  </fieldset>
</template>

<script>
import CustomerTextInput from '@/scripts/components/forms/CustomerTextInput.vue'
import Icon from '@/scripts/components/basic/Icon.vue'

export default {
  name: 'CheckboxInputGroup',
  extends: CustomerTextInput,
  prop: 'selected',
  event: 'input',
  components: {
    Icon
  },
  props: {
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    group: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      inputClass: 'input input--checkbox-group'
    }
  },
  created () {
    const selected = []
    this.options.forEach(opt => {
      if (opt.checked) {
        selected.push(opt.value)
      }
    })
    this.selected = selected
  },
  methods: {
    onChange () {
      this.options.forEach((opt, i) => {
        this.options[i].checked = this.selected.indexOf(opt.value) != -1
      })
      this.$emit('input', this.options)
    }
  }
}
</script>

<style scoped lang="scss">
  fieldset {
    border: none;
  }
</style>
